import {
  DisplayInfo,
  GroupResult,
  ItemResult,
  MenuResult,
} from 'api/ordering-service/ordering-service.types';

type MenuManagementRow = MenuResult | GroupResult | ItemResult;

type RowClassNameType = {
  row: MenuManagementRow;
};

export const getEnglishDisplayInfo = (
  row: Partial<Pick<MenuManagementRow, 'displayInfo'>>,
): DisplayInfo | undefined =>
  row?.displayInfo?.find(
    displayInfo => displayInfo.langCode?.toUpperCase() === 'EN',
  );

/**
 * The row's EN image urls without blank entries. Legacy data can hold `[""]`,
 * which FilePond renders as a broken preview whose removal doesn't clear the
 * form value, so the empty string would be sent back on bulk edit.
 */
export const getEnglishDisplayInfoImages = (
  row: Partial<Pick<MenuManagementRow, 'displayInfo'>>,
  field: 'smallImage' | 'mediumImage',
): string[] =>
  (getEnglishDisplayInfo(row)?.[field] ?? []).filter(url => url?.trim());

/**
 * Bulk edit form field names that differ from the field the ordering service
 * PATCH endpoint expects. `displayTitle` is used on the grid because `title`
 * is already the product's own title column.
 */
export const toBulkUpdateField = (field: string) =>
  field === 'displayTitle' ? 'title' : field;

/**
 * Bulk edit uploads a single image, but the ordering service stores a list
 * (and rejects a blank url), so a removed image is sent as an empty list.
 */
export const toBulkUpdateValue = (field: string, value: any) =>
  field === 'smallImage' || field === 'mediumImage'
    ? value
      ? [value]
      : []
    : value;

export const getRowClassName = ({ row }: RowClassNameType) => {
  switch (row.status?.toUpperCase()) {
    case 'ACTIVE':
      return 'success';
    case 'INACTIVE':
      return 'error';
  }
};
